
























































import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { IPicture } from "@/@types/paintings";

import ChangeDeliteButtons from "@/components/buttons/change-delite-buttons.vue";
import UploadingImagesToServer from "@/components/app/images/uploading-images-to-server.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({
  components: {
    StandartModal,
    delite: ChangeDeliteButtons,
    UploadingImagesToServer,
  },
})
export default class PaintingModeList extends Vue {
  @Inject({ from: "folder", default: "" }) readonly folder!: string;
  @Prop({ type: Array, default: () => [] }) paintings!: Array<IPicture>;
}
